// extracted by mini-css-extract-plugin
export default {"header":"styles_header__1bE30","inputFiledWrapper":"styles_inputFiledWrapper__NyZy7"};